import request from "arcdynamic-request";

// upload file to arc
export function uploadFile({fileName, base64File, folder}) {
    return request(arc.path.api, {
        service: 'arcimedes',
        action: 'open.File.update',
        params: [
            base64File,
            fileName,
            folder,
            true,
        ]
    });
}